import { ReactElement, useState } from "react";

import { currentUserVar } from "@cache/cache";
import { TopicflowIcon } from "@components/topicflow-icon/topicflow-icon";
import useUserComboboxQuery from "@components/user-combobox/use-user-combobox-query";
import UserCombobox, {
  UserComboboxButtonProps,
} from "@components/user-combobox/user-combobox";
import {
  UserComboboxOption,
  UserComboboxOptionType,
  UserComboboxUserOption,
} from "@components/user-combobox/user-combobox-list";

const RecipientDropdown = ({
  recipients,
  onChangeRecipient,
  children,
  showCurrentUser,
  excludeUserIds = [],
  placeholder,
}: {
  onChangeRecipient: (option: UserComboboxUserOption) => void;
  recipients: { id: number }[];
  excludeUserIds?: number[];
  className?: string;
  children?: ReactElement<UserComboboxButtonProps>;
  showCurrentUser?: boolean;
  placeholder?: string;
}) => {
  const currentUser = currentUserVar();
  const recipientIds = recipients.map(({ id }) => id);
  const [canLoadData, setCanLoadData] = useState(false);
  const { loading, options, query, setQuery } = useUserComboboxQuery({
    queryOptions: {
      skip: !canLoadData,
    },
    excludeUserIds: [
      ...excludeUserIds,
      ...(showCurrentUser ? recipientIds : [...recipientIds, currentUser.id]),
    ],
  });

  const handleChangeOwner = (option: UserComboboxOption) => {
    if (option.type === UserComboboxOptionType.USER) {
      onChangeRecipient(option);
    }
  };

  const handlePreloadData = () => {
    setCanLoadData(true);
  };

  return (
    <UserCombobox
      aria-label="Recipient dropdown"
      loading={loading}
      query={query}
      value={null}
      options={options}
      onChangeValue={handleChangeOwner}
      onChangeQuery={setQuery}
      onClickButton={handlePreloadData}
      placeholder={placeholder}
    >
      {children ? (
        children
      ) : (
        <UserCombobox.Button>
          <TopicflowIcon type="plus" className="h-4 w-4" />
          {placeholder ? placeholder : "Pick a user"}
        </UserCombobox.Button>
      )}
    </UserCombobox>
  );
};

export default RecipientDropdown;
